module.exports = __webpack_public_path__ + "static/media/w_y_0.690625fc.png";